module.exports = __webpack_public_path__ + "static/media/3.6d0c1a13.png";